import { UserPreferencesConfig } from 'softcat:config/user-preferences.ts';
import { SoftcatApiCatalogue } from 'softcat:types/softcat-api.ts';
import { SearchParameterUtils } from 'softcat:utils/search-parameters.ts';
import { SoftcatApiUtils } from 'softcat:utils/softcat-api.ts';

const create = async (data: Partial<SoftcatApiCatalogue>): Promise<SoftcatApiCatalogue> => {
    const territory = localStorage.getItem(UserPreferencesConfig.TerritoryStorageKey);
    const parameters = new URLSearchParams(SearchParameterUtils.removeEmptySearchParameters({ territory: `${territory}` }));

    return SoftcatApiUtils.post<SoftcatApiCatalogue>(`/catalogues?${parameters}`, { body: { ...data, territory } });
};

const findAll = async ({ limit = 10, page = 0, query = '', orderBy = '' }: { limit?: number; orderBy?: string; page?: number; query?: string } = {}): Promise<
    SoftcatApiCatalogue[]
> => {
    const territory = localStorage.getItem(UserPreferencesConfig.TerritoryStorageKey);
    const parameters = new URLSearchParams(
        SearchParameterUtils.removeEmptySearchParameters({
            filter: `territory=${territory}${query ? `,name==*${query}*` : ''}`,
            limit: `${limit}`,
            offset: `${page}`,
            orderBy: `${orderBy}`,
            territory: `${territory}`,
        }),
    );

    return SoftcatApiUtils.get<SoftcatApiCatalogue[]>(`/catalogues?${parameters}`);
};

const findOne = async ({ name, version }: { name: string; version: string }): Promise<SoftcatApiCatalogue> => {
    const territory = localStorage.getItem(UserPreferencesConfig.TerritoryStorageKey);
    const parameters = new URLSearchParams(SearchParameterUtils.removeEmptySearchParameters({ territory: `${territory}` }));

    return SoftcatApiUtils.get<SoftcatApiCatalogue>(`/catalogues/${name}/${version}?${parameters}`);
};

const publish = async ({
    certificate,
    location,
    name,
    password,
    version,
}: {
    certificate: File;
    location: string;
    name: string;
    password: string;
    version: string;
}): Promise<SoftcatApiCatalogue> => {
    const territory = localStorage.getItem(UserPreferencesConfig.TerritoryStorageKey);
    const parameters = new URLSearchParams(SearchParameterUtils.removeEmptySearchParameters({ territory: `${territory}` }));

    const form = new FormData();
    form.append('file', certificate);
    form.append('password', password);

    return SoftcatApiUtils.post<SoftcatApiCatalogue>(`/catalogues/action/publish/${name}/${version}/${location}?${parameters}`, { body: form });
};

const remove = async ({ name, version }: { name: string; version: string }): Promise<void> => {
    const territory = localStorage.getItem(UserPreferencesConfig.TerritoryStorageKey);
    const parameters = new URLSearchParams(SearchParameterUtils.removeEmptySearchParameters({ territory: `${territory}` }));

    return SoftcatApiUtils.remove(`/catalogues/${name}/${version}?${parameters}`);
};

const update = async ({ data, name, version }: { data: Partial<SoftcatApiCatalogue>; name: string; version: string }): Promise<SoftcatApiCatalogue> => {
    const territory = localStorage.getItem(UserPreferencesConfig.TerritoryStorageKey);
    const parameters = new URLSearchParams(SearchParameterUtils.removeEmptySearchParameters({ territory: `${territory}` }));

    return SoftcatApiUtils.put<SoftcatApiCatalogue>(`/catalogues/${name}/${version}?${parameters}`, { body: data });
};

export const CatalogueService = {
    create,
    findAll,
    findOne,
    publish,
    remove,
    update,
};
